import React from 'react';

import { Skeleton } from '@sololearnorg/sol';

export function QuestionsListLoading() {
	return (
		<>
			{Array(10)
				.fill(null)
				.map((i, index) => (
					<div className="discuss-questions-list" key={index}>
						<div className="discuss-questions-list__item">
							<div className="discuss-questions-list__item__left-part">
								<Skeleton.Text
									width="200"
									className="discuss-questions-list__item__title"
								/>
								<Skeleton.Text className="discuss-questions-list__item__tags" />
								<Skeleton.Text className="discuss-questions-list__item__info" />
							</div>
							<Skeleton.Avatar />
						</div>
					</div>
				))}
		</>
	);
}
